import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import setupAtnd from '@/lib/ant-design-vue';
import echarts from '@/lib/echarts';
import router from '@/router';
import axios from '@/utils/http';
import CIcon from '@/components/CIcon/index.vue';
import Empty from '@/components/Empty';
import 'virtual:svg-icons-register';
import svgIcon from '@/components/SvgIcon/index.vue';
import { userStore } from '@/store/system/user';
import 'animate.css';
import './permission';
import { RouteRecordRaw } from 'vue-router';
import './assets/styles/common/var.css';
import initDirective from './directives';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons'; // 你也可以导入其他图标集
import config from './config';

// 将图标添加到库
library.add(fas);

const app = createApp(App);
// app.use(router);
initDirective(app);

// 注册全局 FontAwesomeIcon 组件
app.component('FontAwesomeIcon', FontAwesomeIcon);

app.component('CIcon', CIcon);
app.component('Empty', Empty);
app.use(createPinia());
app.component('SvgIcon', svgIcon);
setupAtnd(app);
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$echarts = echarts;
// app.mount('#app');
const isVerifyPermissions = window as unknown as {
  config: { isVerifyPermissions: boolean };
};
fetch(`/project-manager-api/app/license/validate`, {
  method: 'POST',
  body: JSON.stringify({ code: config.appCode }),
  headers: {
    'Content-Type': 'application/json',
  },
})
  .then((res) => res.json())
  .then((res: { data: boolean }) => {
    if (!res || res.data === false) {
      return;
    }
    // const userUseStore = userStore();
    // userUseStore.addRouters.forEach((r) =>
    //   router.addRoute(r as unknown as RouteRecordRaw)
    // );
    // router.addRoute({
    //   path: '/:pathMatch(.*)*',
    //   name: 'NotFound',
    //   component: () => import('@/views/system/exception/403/index.vue'),
    // });

    app.use(router);
    router.isReady().then(() => {
      app.mount('#app');
    });
  });
// sfyxj().then(() => {
//   const userUseStore = userStore();
//   if (isVerifyPermissions) {
//     userUseStore.getUserInfo().then((redirect) => {
//       userUseStore.addRouters.forEach((r) =>
//         router.addRoute(r as unknown as RouteRecordRaw)
//       );
//       router.addRoute({
//         path: '/:pathMatch(.*)*',
//         name: 'NotFound',
//         component: () => import('@/views/system/exception/403/index.vue'),
//       });

//       app.use(router);
//       router.isReady().then(() => {
//         app.mount('#app');
//       });
//     });
//   } else {
//     app.use(router);
//     router.isReady().then(() => {
//       app.mount('#app');
//     });
//   }
// });

// app.use(router);
// router.isReady().then(() => {
//   app.mount('#app');
// });
